export default function getNextItemLink (activeItem, assignment, itemNumber) {
  let nextItemLinkTo
  const thisItemKey = activeItem.key
  const unitKeys = Object.keys(assignment.units)
  const thisItemIndex = unitKeys.indexOf(thisItemKey)
  const nextItemKey = unitKeys[thisItemIndex + 1]
  let nextItemId

  assignment.units[nextItemKey] 
  ? nextItemId = assignment.units[nextItemKey].itemId
  : nextItemId = ''

  nextItemId
  ? nextItemLinkTo = {link: `/assignments/assignment/${assignment.assignmentId}/${nextItemId}?item=${parseInt(itemNumber, 10) + 1}`, last: false}
  : nextItemLinkTo = {link: `/assignments/assignment/${assignment.assignmentId}`, last: true}

  return nextItemLinkTo
}


// WEBPACK FOOTER //
// ./src/helpers/getNextItemLink.js